import { render, staticRenderFns } from "./FixedFooter.vue?vue&type=template&id=11d68001&scoped=true&"
var script = {}
import style0 from "./FixedFooter.vue?vue&type=style&index=0&id=11d68001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d68001",
  null
  
)

export default component.exports